import React from 'react'
import api from 'configs/api'
import { alertSuccess, alertDanger } from 'utils/toast'
import { translate } from 'locales'
import axios from 'axios'

export const findUserData = async (
  setUserData: React.Dispatch<React.SetStateAction<any>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    const find = await api.get('/doctors/v1/users/me')

    const dataStorage: any = window.localStorage.getItem('@StarBem:user')
    const dataParse = JSON.parse(dataStorage)

    const specialties: { id: string; name: string }[] = []
    find.data.doctor.specialties.forEach((item: any) => {
      const temp = {
        id: item.id,
        name: item.name,
        type: 1,
        status: item.status,
      }

      if (item.status === 'active') {
        specialties.push(temp)
      }
    })

    const data = {
      ...dataParse,
      ...find.data.doctor,
      specialties,
    }

    setUserData({
      ...dataParse,
      ...data,
    })

    window.localStorage.setItem(
      '@StarBem:user',
      JSON.stringify({ ...dataParse, ...data })
    )

    setLoading(false)
  } catch (err: any) {
    alertDanger(
      err?.response?.data?.message || translate('errors.errorLoadingData')
    )
    setLoading(false)
  }
}

export const handleAreaSelection = (
  e: any,
  area: any,
  userData: any,
  setUserData: React.Dispatch<React.SetStateAction<any>>
) => {
  const updatedOccupations = userData.specialties.filter(
    (item: any) => item.id !== area.id
  )

  if (e.target.checked) {
    updatedOccupations.push({
      id: area.id,
      name: area.name,
      type: 1,
    })
  } else {
    updatedOccupations.push({ id: area.id, name: area.name, type: 0 })
  }

  setUserData({ ...userData, specialties: updatedOccupations })
}

export const updateUserData = async (
  data: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setNewPassword: React.Dispatch<React.SetStateAction<string>>,
  setNewPasswordConfirm: React.Dispatch<React.SetStateAction<string>>
) => {
  setLoading(true)

  const body = data.password
    ? {
        cellphone: data.profile.cellphone,
        gender: data.profile.gender,
        password: data.password,
      }
    : {
        cellphone: data.profile.cellphone,
        gender: data.profile.gender,
      }

  try {
    await api.put(`/doctors/v1/users/${data.id}`, body)

    alertSuccess(translate('success.dataUpdate'))
    setLoading(false)
    setNewPassword('')
    setNewPasswordConfirm('')
  } catch (err: any) {
    setLoading(false)
    alertDanger(
      err?.response?.data?.message || translate('errors.internalError')
    )
  }
}

export const updateProfileBio = async (
  bio: string,
  userId: string,
  isAIGenerated: boolean = false
): Promise<void> => {
  try {
    const locales = window.localStorage.getItem('@StarBem:lang')
    const lang = locales === 'pt' || !locales ? 'pt-BR' : 'en-US'

    await api.put(`doctors/ms/v1/user/${userId}/bios`, {
      lang,
      bio,
      bio_ia_generated: isAIGenerated,
    })
  } catch (err: any) {
    throw new Error(
      err?.response?.data?.message || translate('errors.internalError')
    )
  }
}

export const uploadProfilePhoto = async (
  file: File,
  doctorId: string
): Promise<void> => {
  const data = new FormData()
  data.append('file', file)

  await api.post(`/doctors/v1/user/${doctorId}/upload`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const generateBioWithAI = async (
  professionalInfo: string
): Promise<string> => {
  const token: any = window.localStorage.getItem('token')

  if (!token) {
    throw new Error('Token do médico não encontrado. Faça login novamente.')
  }

  const response = await axios.post(
    'https://flow.starbem.app/webhook/create/bio',
    { text: professionalInfo },
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  )

  if (response.data?.bio || response.data?.text) {
    return response.data.bio || response.data.text
  }

  throw new Error('Não foi possível gerar a bio. Tente novamente.')
}

export const getProfileBio = async (userId: string): Promise<string | null> => {
  try {
    const response = await api.get(`doctors/ms/v1/user/${userId}/bios`)
    const bios = response.data?.bios || []

    const locales = window.localStorage.getItem('@StarBem:lang')
    const lang = locales === 'pt' || !locales ? 'pt-BR' : 'en-US'

    const bioInLang = bios.find((bioItem: any) => bioItem.lang === lang)

    return bioInLang?.bio || null
  } catch (err: any) {
    if (err?.response?.status === 404) {
      return null
    }
    throw new Error(
      err?.response?.data?.message || translate('errors.internalError')
    )
  }
}
